import { AuditLogWithUser } from '@/typings/auditLog/auditLog';
import api from './baseApi';

export const getAuditEntriesWithUsers = async (entityType: string, entityId: string): Promise<AuditLogWithUser[]> => {
    const response = await api.get('AuditLog', { params: { entityType, entityId } });
    return response.data;
};
